var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bm-container flex-column"},[_c('m-header'),_c('div',{staticClass:"dis-flex flex mb20"},[_c('silder-bar'),_c('div',{staticClass:"main-content"},[_c('keep-alive',{attrs:{"include":_vm.keepAliveArray}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }